<!-- Purchase -->
<ion-grid *ngIf="!!ballotObservable.value && !!ballotObservable.value.players">
  <ion-row>

    <ion-col *ngFor="let player of ballotObservable.value.players; let playerIndex=index;" class="single-cards-selection ion-align-items-center ion-text-center"
      size="6" offset="{{ (playerIndex === 0 && arePlayersOdd) ? 3 : 0 }}">
      <div (click)="toggleSelection(player.id)" [ngClass]="{'selected': isSelected(player.id), 'animate__animated animate__pulse': isSelected(player.id) && animateSelected}">
        <app-tb-player-card [player]="player" [ballot]="ballotObservable.value" [cardSize]="cardsSize"></app-tb-player-card>
        <div class="percentage-container ion-text-center" [ngClass]="{visible: !!votes && !!votes[player.id]}">
          <ion-badge *ngIf="!!votes && !!votes[player.id]" class="percentage-badge" color="tertiary">
            {{ votes[player.id].percentage }}%
          </ion-badge>
        </div>
      </div>
    </ion-col>
  </ion-row>
  <ion-row class="total-votes-container" [ngClass]="{visible: !!totalVotes || totalVotes === 0}">
    <ion-col class="ion-align-items-center ion-text-center" size="12">
      <ion-badge class="total-votes-badge" color="tertiary"> {{ totalVotes }} <br> <ion-text i18n>Voti</ion-text></ion-badge>
    </ion-col>
  </ion-row>
</ion-grid>
